/* src/app/cardholders/personal/personal.component.css */
.hyperlink {
  text-decoration: underline;
  color: #337ab7;
}
/*# sourceMappingURL=personal.component.css.map */
